import { addNewBook } from "../actionCreator";

const addBook = (bookData) => {
    return async (dispatch) => {
        const res = await fetch("http://localhost:9000/books",{
            method: 'POST',
            headers: {
                "Content-type": "application/json; charset=UTF-8"
            },
            body: JSON.stringify(bookData)
        })

        const book = await res.json();
        console.log("bookData:", book)
        dispatch(addNewBook(book));
    }
}

export default addBook;